import { render } from "./QuizAgeField.vue?vue&type=template&id=ac921c30"
import script from "./QuizAgeField.vue?vue&type=script&lang=js"
export * from "./QuizAgeField.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__